module.exports = __webpack_public_path__ + "img/slotto.a06a7568.png";